<template>
  <v-card>
    <v-row v-if="isOpinionScale">
      <v-col cols="12" sm="6" class="mr-n1">
        <annual-review-question-header
          :complete="complete"
          :question="question.question"
          :sectionTitle="section.title"
          :showComplete="!is_user || annualreview_complete"
        ></annual-review-question-header>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col class="px-0">
        <annual-review-question-opinion-answer
          v-on:feedback="
            showFeedbackDialog(
              user_answer,
              annualreview.userQuestionsCompleteDate != null
            )
          "
          :answer="user_answer"
          :disabled="annualreview.userQuestionsCompleteDate != null"
          v-on:answer="saveAnswerRating(user_answer, $event)"
          :user="annualreview.user"
          :showAnswer="
            is_user || annualreview.userQuestionsCompleteDate != null
          "
        >
        </annual-review-question-opinion-answer>
        <template v-if="!is_user || annualreview_complete">
          <v-divider></v-divider>
          <annual-review-question-opinion-answer
            v-on:feedback="
              showFeedbackDialog(
                manager_answer,
                annualreview.managerQuestionsCompleteDate != null
              )
            "
            :answer="manager_answer"
            :disabled="annualreview.managerQuestionsCompleteDate != null"
            v-on:answer="saveAnswerRating(manager_answer, $event)"
            :user="annualreview.manager"
            showAnswer
          >
          </annual-review-question-opinion-answer>
        </template>
      </v-col>
    </v-row>
    <template v-else>
      <v-row>
        <v-col cols="12">
          <annual-review-question-header
            :complete="complete"
            :question="question.question"
            :sectionTitle="section.title"
            :showComplete="!is_user || annualreview_complete"
          ></annual-review-question-header>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-card-text>
        <annual-review-question-text-answer
          :answer="user_answer"
          :showAnswer="!is_user || user_answer.textAnswer"
          :showEdit="annualreview.userQuestionsCompleteDate == null && is_user"
          v-on:edit="showTextAnswerDialog(user_answer)"
          :user="annualreview.user"
        >
        </annual-review-question-text-answer>
        <annual-review-question-text-answer
          v-if="!is_user || annualreview_complete"
          :answer="manager_answer"
          :showAnswer="(manager_answer.textAnswer || '').length > 0"
          :showEdit="
            annualreview.managerQuestionsCompleteDate == null && !is_user
          "
          v-on:edit="showTextAnswerDialog(manager_answer)"
          :user="annualreview.manager"
        >
        </annual-review-question-text-answer>
      </v-card-text>
    </template>
    <edit-annual-review-question-text-dialog
      ref="editTextDialog"
      v-on:save="saveAnswer($event)"
    ></edit-annual-review-question-text-dialog>
    <edit-annual-review-question-feedback-dialog
      ref="editFeedbackDialog"
      v-on:save="saveAnswer($event)"
    ></edit-annual-review-question-feedback-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import EditAnnualReviewQuestionTextDialog from "@/components/annualreviews/EditAnnualReviewQuestionTextDialog";
import EditAnnualReviewQuestionFeedbackDialog from "@/components/annualreviews/EditAnnualReviewQuestionFeedbackDialog";
import AnnualReviewQuestionTextAnswer from "@/components/annualreviews/AnnualReviewQuestionTextAnswer";
import AnnualReviewQuestionOpinionAnswer from "@/components/annualreviews/AnnualReviewQuestionOpinionAnswer";
import AnnualReviewQuestionHeader from "@/components/annualreviews/AnnualReviewQuestionHeader";
export default {
  name: "AnnualReviewQuestion",
  components: {
    EditAnnualReviewQuestionTextDialog,
    EditAnnualReviewQuestionFeedbackDialog,
    AnnualReviewQuestionTextAnswer,
    AnnualReviewQuestionOpinionAnswer,
    AnnualReviewQuestionHeader
  },
  props: { question: { type: Object }, section: { type: Object } },
  data: () => ({ saving: false }),
  computed: {
    isOpinionScale() {
      return (
        this.question.questionTypeId == this.$enums.questionTypes.OPINION_SCALE
      );
    },
    user_answer() {
      return (
        this.annualreview.answers.find(
          x =>
            x.questionId == this.question.id &&
            x.answererId == this.annualreview.user.id
        ) || {
          answer: null,
          textAnswer: null,
          questionId: this.question.id,
          userId: this.annualreview.user.id,
          annualReviewId: this.annualreview.id,
          feedback: null
        }
      );
    },
    manager_answer() {
      return (
        this.annualreview.answers.find(
          x =>
            x.questionId == this.question.id &&
            x.answererId == this.annualreview.manager.id
        ) || {
          answer: null,
          textAnswer: null,
          questionId: this.question.id,
          userId: this.annualreview.user.id,
          annualReviewId: this.annualreview.id,
          feedback: null
        }
      );
    },
    complete() {
      return (
        (this.manager_answer.answer != null ||
          this.manager_answer.textAnswer != null) &&
        (this.user_answer.answer != null || this.user_answer.textAnswer != null)
      );
    },
    annualreview_complete() {
      return (
        this.annualreview.managerQuestionsCompleteDate != null &&
        this.annualreview.userQuestionsCompleteDate != null
      );
    },
    ...mapGetters({
      annualreview: "annualreview/annualreview",
      profile: "profile/profile",
      is_user: "annualreview/is_user"
    })
  },
  methods: {
    showTextAnswerDialog(answer) {
      this.$refs.editTextDialog.showDialog(answer, this.question.question);
    },
    showFeedbackDialog(answer, disabled) {
      this.$refs.editFeedbackDialog.showDialog(answer, disabled);
    },
    saveAnswerRating(answer, rating) {
      this.saveAnswer(Object.assign(answer, { answer: rating }));
    },
    saveAnswer(answer) {
      this.saving = true;
      this.$store
        .dispatch("annualreview/saveQuestionAnswer", answer)
        .then(() => {
          this.$emit("save");
          this.$root.$snackbarSuccess("Answer saved");
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occurred while saving your answer."
          );
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
